
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  section: 'Virtual Accounts',
  title: 'Payment Confirmation',
  description: 'Confirm when funds have settled in a virtual account'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title={metadata.title} subtitle={metadata.description} mdxType="Header" />
    <p>{`Plaid offers Payment Confirmation on top of our `}<a parentName="p" {...{
        "href": "/docs/payment-initiation"
      }}>{`Payment Initiation`}</a>{` APIs. Payment Confirmation provides confirmation of payments settling in your virtual account. Plaid will notify you when funds have settled so you can confidently release those funds to your end users. Each virtual account can receive or send funds on payment rails supported by the currency of the account.`}</p>
    <p>{`The Payment Confirmation flow builds on the Payment Initiation flow, with two main differences:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Payments are initiated with the client-owned virtual account as the recipient.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Optionally, the current balance of the virtual account can be automatically swept (transferred) periodically to your bank account. To use this functionality, reach out to your account manager.`}</p>
      </li>
    </ul>
    <p>{`To your end user, there is no difference between initiating a payment to a virtual account and initiating a payment directly to the recipient bank account.`}</p>
    <h4 {...{
      "id": "confirming-funds-have-settled"
    }}>{`Confirming funds have settled`}</h4>
    <p>{`Make sure your virtual account is set up before following these steps. For more information on setting up an account, see `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/managing-virtual-accounts"
      }}>{`Managing virtual accounts`}</a>{`.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go through the `}<a parentName="p" {...{
            "href": "/docs/payment-initiation/payment-initiation-one-time/"
          }}>{`Payment Initiation flow`}</a>{` and initiate a payment.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Use the `}<inlineCode parentName="li">{`recipient_id`}</inlineCode>{` associated with your `}<inlineCode parentName="li">{`wallet_id`}</inlineCode>{` so Plaid knows to route the payment to your virtual account.`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The payment will settle in your virtual account. You will receive the following webhooks:`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`If you included a webhook URL when creating your `}<inlineCode parentName="p">{`link_token`}</inlineCode>{` you will receive a `}<a parentName="p" {...{
                "href": "/docs/api/products/payment-initiation/#payment_status_update"
              }}>{`payment status update`}</a>{` that the payment is now `}<inlineCode parentName="p">{`PAYMENT_STATUS_SETTLED`}</inlineCode>{`. This is the primary webhook that indicates payment confirmation.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`If you configured a webhook through the `}<a parentName="p" {...{
                "href": "https://dashboard.plaid.com/developers/webhooks"
              }}>{`Plaid Dashboard`}</a>{`, you will also receive a `}<a parentName="p" {...{
                "href": "/docs/api/products/virtual-accounts/#wallet_transaction_status_update"
              }}>{`status update`}</a>{` that a transaction of type `}<inlineCode parentName="p">{`PIS_PAY_IN`}</inlineCode>{` transitioned from `}<inlineCode parentName="p">{`INITIATED`}</inlineCode>{` to `}<inlineCode parentName="p">{`SETTLED`}</inlineCode>{` in your virtual account. This webhook indicates an update to your virtual account with the funds that have settled (i.e., the transaction that corresponds to the payment that settled).`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`In addition to webhooks, you can check if the payment has settled by calling `}<inlineCode parentName="p">{`/payment_initiation/payment/get`}</inlineCode>{` with the `}<inlineCode parentName="p">{`payment_id`}</inlineCode>{` from Step 1.`}</p>
          </li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Once the payment has settled, you can safely release funds to your end user.`}</p>
      </li>
    </ol>
    <p>{`In the UK, payments settle nearly instantly and run on the Faster Payments rail. In the Eurozone, Plaid defaults to SEPA Credit Transfer, which settles within one business day (approximately 12 hours later, if both the payment initiation date and the next day are business days). If you want to use SEPA Instant Credit Transfer for faster settlement times (within seconds, 24/7), you can specify the payment scheme when creating the payment.`}</p>
    <h4 {...{
      "id": "testing-payment-confirmation"
    }}>{`Testing Payment Confirmation`}</h4>
    <p>{`You can begin testing Payment Confirmation in Sandbox by following the steps listed in the `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/add-to-app/"
      }}>{`Add Virtual Accounts to your App`}</a>{` guide. For Production access you will first need to `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/support/new/admin/account-administration/request-product-access"
      }}>{`submit a product access request support ticket`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "confirming-funds-have-settled",
        level: 4,
        title: "Confirming funds have settled",
      },
{
        id: "testing-payment-confirmation",
        level: 4,
        title: "Testing Payment Confirmation",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
